if (!customElements.get("vbb-wishlist-link")) {
  customElements.define(
    "vbb-wishlist-link",
    class WishlistLink extends HTMLElement {
      constructor() {
        super();

        this.anchor = this.closest('a.header__icon--wishlist')
        document.addEventListener('wishlist:fetch-lists:success', () => this.init());
      }

      init() {
        if (window.globalSwymWishlist?.lists[0]?.listcontents?.length) {
          this.classList.add('is-full');
        } else {
          this.classList.remove('is-full');
        }

        this.anchor.classList.remove('hidden')
      }
    }
  );
}
